import addError from '../../../utils/error.jsx';
import * as getChat from './get-chat';
import * as getNotifications from '../../notifications/actions/get';

export function request(chatId) {
    return {
        type: 'TRADER_CHAT_ASSIGN_CHAT_REQUEST',
        chatId,
    };
}

export function error(chatId, errors) {
    addError(errors);

    return {
        type: 'TRADER_CHAT_ASSIGN_CHAT_ERROR',
        chatId,
        errors,
    };
}

export function finish(chatId) {
    return (dispatch) => {
        dispatch(getChat.request(chatId));
        // dispatch(getNotifications.request());

        dispatch({
            type: 'TRADER_CHAT_ASSIGN_CHAT_FINISH',
            chatId,
        });
    };
}
